import { Injectable, signal } from '@angular/core';

const KEY = 'vo-user-chrome';

/**
 * Light/dark treatment for the authed nav chrome (top bar + rails + breadcrumb).
 * Content stays light; only the chrome flips — mirrors the admin console toggle.
 * Persisted so it survives reloads.
 */
@Injectable({ providedIn: 'root' })
export class ChromeService {
  readonly theme = signal<'light' | 'dark'>(this.read());

  toggle(): void {
    this.theme.update(t => (t === 'light' ? 'dark' : 'light'));
    try {
      localStorage.setItem(KEY, this.theme());
    } catch {
      /* storage unavailable — non-fatal */
    }
  }

  private read(): 'light' | 'dark' {
    try {
      return localStorage.getItem(KEY) === 'dark' ? 'dark' : 'light';
    } catch {
      return 'light';
    }
  }
}
